'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './DataTable.module.css';
export function Toolbar({ children, className, style }) {
    const cls = [styles.toolbar, className].filter(Boolean).join(' ');
    return (_jsx("div", { role: "toolbar", "aria-label": "Table controls", className: cls, style: style, children: children }));
}
//# sourceMappingURL=Toolbar.js.map